import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../datasource/api";
import { AddAccountManager } from "./IaccountManager";
import axios, { AxiosError } from "axios";
import { UserAuditInfoType } from "../../modals/IuserAuditInfo";
import routesName from "../../constants/routesName";
import CryptoJS from "crypto-js";
import { jwtDecode } from "jwt-decode";
import constanstObject from "../../constants";
import { accessTokenType } from "../../modals/IloginCard";
// add account manager
export const addAccountManager = createAsyncThunk(
  "post/add-account-manager",
  async (data: AddAccountManager, { rejectWithValue }) => {
    try {
      const response = await API.post(
        "AccountManager/AccountManager/Add",
        data
      );
      console.log(data, 'acc role');

      const {
        name = "asdasdasd",
        phone = "6456876456",
        email = "5dokfosdkfkl@gmail.com",
        gender = "Male",
        password = "Stayfit@2025",
      } = data;

      const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
      const AES_IV = '1208987836506021';
      const encryptString = (plainText: string) => {
        const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY || "");
        const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV || "");
        const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 });
        return encrypted.toString();
      };

      const dataPost = {
        email: email ?? "",
        password: encryptString(password ?? ""),
        firstName: name ?? "",
        lastName: "-",
        phoneNumber: phone ?? "",
        department: "",
        hospitalid: "qweweada6025",
        degree: "",
        gender: gender,
      };

      try {
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('newlogin')} `, // Add token here
        };
        const url: string = process.env.REACT_APP_MA_REGISTER_URL as string;

        const response = await axios.post(url, dataPost, { headers });
        console.log("Response:", response.data);

        // const MAPROLEURL = process.env.REACT_APP_MA_MAP_USER_ROLE_URL || ''
        // axios.post(MAPROLEURL, { userId: response?.data?.userId, hospitalid: responseHospital.data?.data }, { headers, })

        const params = {
          email: dataPost?.email,
          ModuleId: 2,
        };
        const data2 = [
          'MAHospitalManagement'
        ];
        const addRoleURl = process.env.REACT_APP_MA_ROLE_URL || ''
        axios.post(addRoleURl, data2, { headers, params })
          .then(response => {
            console.log('Response:', response.data);

          })
          .catch(error => {
            console.error('Error:', error);
          });
        // return response.data;
      } catch (error) {
        console.error("Error in POST request:", error);
        throw error;
      }

      return response.data;
    } catch (error: unknown) {
      // if (error instanceof AxiosError) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      // }
      return rejectWithValue(error);
    }
  }
);

// get permissions of user
export const getPermissions = createAsyncThunk(
  "get/permissions",
  async (data, { rejectWithValue }) => {
    try {
      const response = await API.get(
        "AccountManager/AccountManagers/RolePermissions"
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

// get all account manager
export const getAllAccontManager = createAsyncThunk(
  "get/all-accountManager",
  async (
    data: {
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `AccountManager/AccountManagers?order=${data.order}&orderBy=${data.orderBy
        }${data.searchQuery ?? ""}&page=${data.page + 1}&pageSize=${data.rowsPerPage
        }&searchKeywords=${data?.searchKeywords}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

// get account manager
export const getAccontManager = createAsyncThunk(
  "get/accountManager",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await API.get(
        `AccountManager/AccountManager/Id?userid=${id}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

// update account manager
// export const updateAccontManager = createAsyncThunk(
//   "update/accountManager",
//   async (data: AddAccountManager, { rejectWithValue }) => {
//     try {
//       console.log(48484848, data)
//       const response = await API.post(
//         `AccountManager/AccountManager/Update`,
//         data
//       );

//       return response.data;
//     } catch (error: unknown) {
//       if (error instanceof AxiosError) {
//         if (error?.response?.status === 500) {
//           window.location.href = routesName.errorPage;
//         }
//       }
//       return rejectWithValue(error);
//     }
//   }
// );
// export const updateAccontManager = createAsyncThunk(
//   "update/accountManager",
//   async (data: AddAccountManager, { rejectWithValue }) => {
//     try {
//       console.log(data, 374747)
//       const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
//       const AES_IV = '1208987836506021';
//       const encryptString = (plainText: string) => {
//         const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY || "");
//         const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV || "");
//         const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 });
//         return encrypted.toString();
//       };
//       const dataFormatted = {
//         email: data?.email ?? "",
//         password: data?.password ? encryptString(data?.password as any || "") : null,
//         firstName: data?.name ?? "",
//         lastName: data?.name?.pop?.() || "-",
//         phoneNumber: data?.phone ?? "",
//         IsPasswordChangeOnLogin: data?.isTempPassword,
//         userId: data?.userId ?? null,
//       }

//       // const Email = data.email;
//       // const NewPassword = encryptString(data.password as any);
//       const url = process.env.REACT_APP_MA_EDIT_HOSPITAL_URL || '';
//       const headers = {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${sessionStorage.getItem('newlogin')} `, // Add token here
//       };


//       const maResponse = await axios.post(url, dataFormatted, { headers });

//       if (maResponse) {
//         const response = await API.post(
//           `AccountManager/AccountManager/Update`,
//           data
//         ); return response.data;
//       }
//     } catch (error: any) {
//       // if (error?.response?.status === 500) {
//       //   window.location.href = routesName.errorPage;
//       // }
//       return rejectWithValue(error);
//     }
//   }
// );

export const updateAccontManager = createAsyncThunk(
  "update/accountManager",
  async (data: AddAccountManager, { rejectWithValue }) => {
    try {
      const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
      const AES_IV = '1208987836506021';

      const encryptString = (plainText: string) => {
        const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY);
        const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV);
        return CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 }).toString();
      };

      const dataFormatted = {
        email: data?.email ?? "",
        password: data?.password ? encryptString(data.password) : null,
        firstName: data?.name ?? "",
        lastName: Array.isArray(data?.name)
          ? data.name[data.name.length - 1]
          : "-",
        phoneNumber: data?.phone ?? "",
        IsPasswordChangeOnLogin: data?.isTempPassword,
        userId: data?.userId ?? null,
      };

      const url = process.env.REACT_APP_MA_EDIT_HOSPITAL_URL || '';
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('newlogin')}`,
      };

      // ✅ Step 1: MA API
      const maResponse = await axios.post(url, dataFormatted, { headers });

      if (maResponse.status !== 200) {
        return rejectWithValue("MA API failed");
      }

      // ✅ Step 2: Main API
      const response = await API.post(
        `AccountManager/AccountManager/Update`,
        data
      );

      if (!response?.data) {
        return rejectWithValue("Update API failed");
      }

      // ✅ Step 3: Role API (non-blocking but controlled)
      try {
        const addRoleURL = process.env.REACT_APP_MA_ROLE_URL || '';

        const params = {
          email: data?.email,
          ModuleId: 2,
        };

        const data2 = ['MAHospitalManagement'];

        const roleResponse = await axios.post(addRoleURL, data2, {
          headers,
          params,
        });

        console.log('Role Response:', roleResponse.data);
      } catch (roleError) {
        console.error('Role API Error:', roleError);
      }

      return response.data;

    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || error.message || "Something went wrong"
      );
    }
  }
);

// get hospital data by account manager linked
export const getHospitalsLinkedAccManager = createAsyncThunk(
  "get/hospital-linked-to-accountManager",
  async (
    data: {
      userId: number;
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `AccountManager/AccountManager/Hospitals?userid=${data?.userId}&order=${data.order
        }&orderBy=${data.orderBy}${data.searchQuery ?? ""}&page=${data.page + 1
        }&pageSize=${data.rowsPerPage}&searchKeywords=${data?.searchKeywords}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

// get status wise hospital data by account manager linked
export const getStatusWiseHospitalsLinkedAccManager = createAsyncThunk(
  "get/status-wise-hospital-linked-to-accountManager",
  async (
    data: {
      userId: number;
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords: string;
      status: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `AccountManager/AccountManager/Hospitals/Status?userid=${data?.userId
        }&status=${data.status}&order=${data.order}&orderBy=${data.orderBy}${data.searchQuery ?? ""
        }&page=${data.page + 1}&pageSize=${data.rowsPerPage}&searchKeywords=${data?.searchKeywords
        }`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

// get hopsital list

export const getHospitalsIdList = createAsyncThunk(
  "get/hospitals-id-list",
  async (data, { rejectWithValue }) => {
    try {

      const accessToken = sessionStorage.getItem(constanstObject.accessTokenText);
      const user: accessTokenType = jwtDecode(accessToken || "");
      const userRole = user?.Roles || "";
      console.log(user);
      console.log(userRole);
      const userId = userRole == "Admin" ? user?.userId : undefined;

      const response = await API.get(
        `AccountManager/AccountManagers/HospitalsDropdownList${userId ? `?userid=${userId}` : ""}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

// activate deactivate account manager user

export const activateDeactiveAccManager = createAsyncThunk(
  "active-deactivate/account-manager",
  async (data: { userId: number; isActive: number }, { rejectWithValue }) => {
    try {
      const response = await API.post(
        `AccountManager/AccountManager/ActivateOrDeActivate?userid=${data.userId}&isactive=${data.isActive}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

//  delete account manager user
export const deleteAccManager = createAsyncThunk(
  "delete/account-manager",
  async (userId: number, { rejectWithValue }) => {
    try {
      const response = await API.delete(
        `AccountManager/AccountManager/delete/id?userid=${userId}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

//  delete account manager user
export const linkHospitalToAccManager = createAsyncThunk(
  "link/hosiptal-to-account-manager",
  async (
    data: { userId: number; hospitalId: string[]; isToBeLinked?: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.post(
        `AccountManager/AccountManager/LinkOrDeLink?userid=${data?.userId}&isToBeLinked=${data?.isToBeLinked}`,
        data?.hospitalId
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

// resest password

//  delete account manager user
// export const resetPasswordAccManager = createAsyncThunk(
//   "reset/account-manager-password",
//   async (
//     data: {
//       email: string;
//       password: string;
//       isTempPassword: boolean;
//       userAuditInfo: UserAuditInfoType;
//     },
//     { rejectWithValue }
//   ) => {
//     try {
//       const response = await API.post(`Profile/passwordreset`, data);
//       return response.data;
//     } catch (error: unknown) {
//       if (error instanceof AxiosError) {
//         if (error?.response?.status === 500) {
//           window.location.href = routesName.errorPage;
//         }
//       }
//       return rejectWithValue(error);
//     }
//   }
// );
export const resetPasswordAccManager = createAsyncThunk(
  "reset/account-manager-password",
  async (
    data: {
      email: string;
      password: string;
      isTempPassword: boolean;
      userAuditInfo: UserAuditInfoType;
    },
    { rejectWithValue }
  ) => {
    try {
      console.log(data, 374747)
      const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
      const AES_IV = '1208987836506021';
      const encryptString = (plainText: string) => {
        const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY || "");
        const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV || "");
        const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 });
        return encrypted.toString();
      };

      const Email = data.email;
      const NewPassword = data.password ? encryptString(data.password as any || "") : null;
      const url = process.env.REACT_APP_MA_RESET_PASSWORD_URL || '';
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('newlogin')} `, // Add token here
      };

      const maResponse = await axios.post(url, { Email, NewPassword }, { headers });

      if (maResponse) {
        const response = await API.post(`Profile/passwordreset`, data);
        return response.data;
      }
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);


//get user audit data by account amnager linked
export const getUserAuditLinkedAccManager = createAsyncThunk(
  "get/Audit-linked-to-accountManager",
  async (
    data: {
      userId: number;
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/UserAudit/getAudit?userid=${data.userId}&order=${data.order
        }&orderBy=${data.orderBy}${data.searchQuery ?? ""}&page=${data.page + 1
        }&pageSize=${data.rowsPerPage}&searchKeywords=${data?.searchKeywords}`
      );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 500) {
        window.location.href = routesName.errorPage;
      }
      return rejectWithValue(error);
    }
  }
);
